/**
 * Shared layout styles for the V2 page shell (container + filter/action row).
 */
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const usePageShellStyles = createStyles({
  container: {
    width: "100%",
    height: "100%",
    overflow: "auto",
    padding: tokens.spacing[20],
    display: "flex",
    flexDirection: "column",
    color: tokens.color.semantic.text.bold,
    gap: tokens.spacing[6],
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
});
